<template>
    <div class="ntpReport">
        <lgn-input class="ntpReport-search" placeholder="請輸入場站代碼" v-model="searchText" 
        :suffix="true" :suffix-icon="'el-icon-search'" :suffix-method="searchNtpReport"
        @keyup.enter.native="searchNtpReport"></lgn-input>
        <div class="paca-table">
            <div class="paca-table__header">
                <div class="paca-table__header-item item-column column-name">{{$t("table.header.siteName")}}</div>
                <div class="paca-table__header-item item-column column-site">{{$t("table.header.site")}}</div>
                <div class="paca-table__header-item item-column column-vendor">{{$t("table.header.vendor")}}</div>
                <div class="paca-table__header-item item-column column-report">報表</div>
            </div>
            <div class="paca-table__body" v-if="ntpListView.length != 0">
                <div class="paca-table__body-col" v-for="(item, index) in ntpListView" :key="ntpSearchMode+index">
                    <div class="paca-table__body-col-list">
                        <div class="paca-table__body-col-list-item item-column column-name overflow-text">{{item.name}}</div>
                        <div class="paca-table__body-col-list-item item-column column-site">{{item.site}}</div>
                        <div class="paca-table__body-col-list-item item-column column-vendor">{{item.vendor}}</div>
                        <div class="paca-table__body-col-list-item item-column column-report">
                            <a :href="`https://s3-ap-northeast-1.amazonaws.com/s3.paca.com.tw/period_report/${item.site}_${serverTime}.tgz`" target="_blank" :download="`${item.site}_${serverTime}.tgz`" class="el-icon-receiving column-report-icon"></a>
                        </div>
                    </div>
                </div>
                <button type="button" class="paca-table__body-more" v-if="isShowMoreButton" @click="ntpReportListIteration()">更多</button>
            </div>
            <div class="paca-table__empty" v-else></div>
        </div>
    </div>
</template>
<script>
import * as api from '@/script/apiService/api.js'
import lgnInput from '@/lgnComponents/lgnInput/lgnInput.vue'
export default {
    name: "ntpReport",
    components: {
        lgnInput
    },
    data(){
        return{
            ntpList: {
                all: [],
                search: []
            },
            viewNtpList: {
                all: [],
                search: []
            },
            tableLoading: false,
            ntpSearchMode: "all",
            searchText: "",
            viewMoreCount: 0,
            isShowMoreButton: true,
            serverTime: ""
        }
    },
    methods: {
        searchNtpReport(){
            this.viewMoreCount = 0;
            this.isShowMoreButton = true;
            let searchText = this.searchText;
            this.ntpSearchMode = "search";
            this.viewNtpList.search = [];
            let searchedList = [];
            this.$nextTick(() => {
                this.tableLoading = true;
            })
            setTimeout(function(){
                this.ntpList.all.forEach(item => {
                    if(item.site.indexOf(searchText) != -1){
                        searchedList.push(item);
                    }
                })
                this.tableLoading = false;
                setTimeout(function(){
                    this.ntpList.search = searchedList;
                    this.ntpReportListIteration();
                }.bind(this), 300);
            }.bind(this), 300);
        },
        ntpReportListIteration(){
            if((this.viewMoreCount + 1)*30 > this.ntpList[this.ntpSearchMode].length){
                this.isShowMoreButton = false;
            }
            this.viewNtpList[this.ntpSearchMode] = this.viewNtpList[this.ntpSearchMode].concat(this.ntpList[this.ntpSearchMode].slice(this.viewMoreCount*30, (this.viewMoreCount + 1) * 30));
            this.viewMoreCount += 1;
        },
    },
    computed: {
        ntpListView(){
            return this.viewNtpList[this.ntpSearchMode]
        }
    },
    async activated(){
        this.viewMoreCount = 0;
        this.isShowMoreButton = true;
        this.viewNtpList.all = [];
        this.viewNtpList.search = [];
        this.$nextTick(() => {
            this.tableLoading = true;
        })
        let res = await api.getNtpReportList();
        if(!res.error_status){
            res.sort(function(a, b){
                if(a.site > 7){
                    return 1
                } else if(a.site > b.site){
                    return 1
                } else if(a.site < b.site){
                    return -1
                } else {
                    return 0
                }
            })
            setTimeout(function(){
                this.tableLoading = false;
                setTimeout(function(){
                    this.ntpList.all = res;
                    this.ntpReportListIteration();
                }.bind(this), 300);
            }.bind(this), 300);
        } else if(res.error_status == '403'){
            this.tableLoading = false;
            this.$message.error({
                showClose: true,
                duration: 2500,
                message: "您尚未擁有此權限!"
            })
        }
        let userRes = await api.getUserLogin();
        if(!userRes.error_status){
            let ServerTime = userRes.server_time;
            let serverMonth = ServerTime.split("").slice(5,7).join("") - 1;
            serverMonth = serverMonth < 10 ? '0' + serverMonth : serverMonth;
            let serverYear = ServerTime.split("").slice(0,4).join("");
            if(serverMonth == '01'){
                serverYear -= 1;
                serverMonth = '12';
            }
            this.serverTime = `${serverYear}_${serverMonth}`;
        } 
    },
    watch: {
        tableLoading(value){
            let hasData = document.querySelector(".paca-table__body");
            let loadingStyle = "";
            let asideWidth = document.querySelector(".el-aside").offsetWidth;
            if(hasData){
                loadingStyle = hasData.offsetHeight > document.querySelector(".el-main").offsetHeight/2 ? 'screen-align' : 'empty-align';
            }
            if(asideWidth > 150){
                loadingStyle += " collapse-open";
            }else if(asideWidth > 50){
                loadingStyle += " collapse-exist";
            }
            if(value == true){
                this.loadingMethod = this.$loading({
                    lock: true,
                    target: '.paca-table__empty',
                    text: '搜尋中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(255,255,255,0.8)',
                    customClass: loadingStyle
                });
            }else{
                if(this.loadingMethod != null){
                    this.loadingMethod.close();
                }
            }
        }
    },
}
</script>